import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables';
import { AUDITING_API } from '@Constants/backendConstants';
import { commandAuditLogColumns } from '@Constants/TableColumns';
import { EnumFrontendLayoutSetting, type ApiCommandAuditLog } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { CommandAuditLogsRepository } from '@Repositories/Auditing';

export function FrameListCommandAuditLog() {
    const { loadPage } = useListApi(CommandAuditLogsRepository, AUDITING_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiCommandAuditLog>
            layoutSettingsContext={EnumFrontendLayoutSetting.CommandAuditLogsTableLayout}
            name="CommandAuditLogsList"
            columns={commandAuditLogColumns}
            initialSorting={{ columnName: 'created_at', direction: 'desc' }}
            loader={loadPage}
            canCreate={false}
            useOnClickNavigation
            fullSize
        />
    );
}
